import LookupWorkloadSummaryRequestModelBase from '../_generated/modelBases/lookup-workload-summary-request-model-base';

export default class LookupWorkloadSummaryRequestModel extends LookupWorkloadSummaryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
